const storages = {
  accountInfo: 'account-info',
  walletInfo: 'wallet-info',
  pubKey: 'publicKey',
};
export { storages };
